import { render, staticRenderFns } from "./Headerbanner.vue?vue&type=template&id=4e341c65&scoped=true&"
import script from "./Headerbanner.vue?vue&type=script&lang=js&"
export * from "./Headerbanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e341c65",
  null
  
)

export default component.exports